import routerUtils from '../../../lib/routerUtils'
import SessionStore from '../stores/SessionStore'

const preAuthHook = () => {
  if (!SessionStore.getState().preAuthenticated)
    routerUtils.replace('/auth/sign_in')
}

export default preAuthHook
